import firebase from "firebase/compat/app";
import { Result } from '../../shared/types';
import { analyticsService } from "../analytics";
import { storage } from "./app";

export async function uploadFile(
    fileList: FileList,
    options?: { onProgress?: (percent: number) => void }
): Promise<Result> {
    try {
        if (!fileList[0]) {
            return {
                success: false,
                error: "FileList does not contain file...",
            };
        }

        const file = fileList[0];
        const storageRef = storage.ref();
        const fileRef = storageRef.child(
            "campaigns/" + firebase.auth().currentUser?.uid + new Date().getTime().toString() + file.name
        );

        if (!options?.onProgress) {
            const uploadTaskSnapshot = await fileRef.put(file);
            const fileUrl = await uploadTaskSnapshot.ref.getDownloadURL();

            return {
                success: true,
                result: fileUrl,
            };
        }

        return await new Promise<Result>((resolve) => {
            const uploadTask = fileRef.put(file);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    if (snapshot.totalBytes > 0) {
                        options.onProgress!(
                            Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
                        );
                    }
                },
                (error) => {
                    console.log(error);
                    analyticsService().logError(error);
                    resolve({ success: false, error });
                },
                async () => {
                    try {
                        const fileUrl = await uploadTask.snapshot.ref.getDownloadURL();
                        resolve({
                            success: true,
                            result: fileUrl,
                        });
                    } catch (e) {
                        console.log(e);
                        analyticsService().logError(e);
                        resolve({ success: false, error: e });
                    }
                }
            );
        });
    } catch (e) {
        console.log(e);
        analyticsService().logError(e);
        return { success: false, error: e };
    }
}
